/**
 * Ändere Custom Liquid Preis für Beans Produkte
 */

document.addEventListener('DOMContentLoaded', function() {

  function updateMemberPrice(variantId) {
    const data = window.variantMemberPrices?.[variantId];
    if (!data) return;

    const weightKg = data.weight / 1000;
    const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

    const regularEl = document.querySelector('.price-item--regular');
    if (regularEl) {
      const pricePerKg = data.price / weightKg;
      regularEl.innerHTML = `
        <span class="price-item__label">Regulärer Preis:</span>
        ${formatter.format(data.price / 100)}
        <span class="price-per-kg">(${formatter.format(pricePerKg / 100)}/kg)</span>
      `;
    }

    const memberEl = document.querySelector('.price-item--member');
    if (memberEl) {
      if (data.member_price) {
        const memberPerKg = data.member_price / weightKg;
        memberEl.innerHTML = `
          <span class="price-item__label">Member-Preis:</span>
          ${formatter.format(data.member_price / 100)}
          <span class="price-per-kg">(${formatter.format(memberPerKg / 100)}/kg)</span>
        `;
        memberEl.closest('.price__member').style.display = 'block';
      } else {
        memberEl.closest('.price__member').style.display = 'none';
      }
    }
  }

  document.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      updateMemberPrice(e.target.value);
    }
  });

});

/**
 * Ändere Button Text "Jetzt buchen" zu "Jetzt anfragen" für Beans to Bar (ID: 15848261517637)
 */
(function () {
    // Nur auf dem spezifischen Produkt ausführen
    var TARGET_PRODUCT_ID = '15848261517637';
    var productId =
      (window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        String(window.ShopifyAnalytics.meta.product.id)) ||
      (window.meta && window.meta.product && String(window.meta.product.id)) ||
      '';

    if (productId !== TARGET_PRODUCT_ID) return;

    var OLD_TEXT = 'Jetzt buchen';
    var NEW_TEXT = 'Jetzt anfragen';

    function replaceText(root) {
      if (!root) return;

      // 1) Cowlendar-Buttons (Add-to-Cart-Ersatz)
      var selectors = [
        'button.cowlendar-atc-button',
        '.cowlendar-atc-button',
        'button[name="add"]',
        'button.product-form__submit',
        '.shopify-payment-button__button',
        '[data-cowlendar] button'
      ];

      selectors.forEach(function (sel) {
        root.querySelectorAll(sel).forEach(function (el) {
          // Inhalt prüfen, damit "Ausverkauft" o.ä. nicht überschrieben wird
          if ((el.textContent ||
  '').trim().toLowerCase().indexOf(OLD_TEXT.toLowerCase()) !== -1) {
            // Nur Textknoten ersetzen, um eventuelle Icons/Spans nicht zu zerstören
            var replaced = false;
            el.childNodes.forEach(function (node) {
              if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
                node.nodeValue = node.nodeValue.replace(new RegExp(OLD_TEXT,
  'gi'), NEW_TEXT);
                replaced = true;
              }
            });
            if (!replaced) el.textContent = NEW_TEXT;
          }
        });
      });
    }

    // Initial + bei DOM-Änderungen (Cowlendar lädt asynchron)
    function init() {
      replaceText(document);
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            replaceText(document);
            break;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();